import { Button } from '@ds/core';
import { Alert } from '@ds/feedback';
import { Radio } from '@ds/forms';
import { moeda } from '@/comuns/formato';
import type { PlanoDoCadastro } from '@/session/autocadastro';

/**
 * Passo 3: o plano. Nome e preço, que é o que o banco tem — a lista de módulos
 * de cada plano não existe como dado, e a tela não a inventa.
 */
export function EtapaPlano({ planos, escolhido, enviando, aoEscolher, aoContinuar, aoVoltar }: {
    planos: PlanoDoCadastro[];
    escolhido: string;
    enviando: boolean;
    aoEscolher: (codigo: string) => void;
    aoContinuar: () => void;
    aoVoltar: () => void;
}) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <h2 style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 17, fontWeight: 600, color: 'var(--text-primary)' }}>Escolha o plano</h2>

            {planos.length === 0 ? (
                <Alert tone="warning" dismissible={false}>
                    Nenhum plano está disponível para contratação agora. Fale com o suporte da Fórmula MED.
                </Alert>
            ) : (
                <div role="radiogroup" aria-label="Plano" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {planos.map((p) => (
                        <Radio
                            key={p.codigo}
                            name="plano"
                            checked={escolhido === p.codigo}
                            onChange={() => aoEscolher(p.codigo)}
                            label={p.nome}
                            description={`${moeda(p.precoCentavos)} por mês`}
                        />
                    ))}
                </div>
            )}

            <p style={{ margin: 0, fontSize: 12.5, lineHeight: '18px', color: 'var(--text-secondary)' }}>
                No cartão, os primeiros 14 dias são grátis. No Pix Automático, o primeiro mês é pago no cadastro.
            </p>

            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                <Button type="button" variant="secondary" onClick={aoVoltar}>Voltar</Button>
                <Button type="button" style={{ flex: 1 }} loading={enviando} disabled={!escolhido || planos.length === 0} onClick={aoContinuar}>
                    Ir para o pagamento
                </Button>
            </div>
        </div>
    );
}
